import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';

const SURVEY_LIST =
  'Sell Out, Display Planogram, Display Matrix, Price Tracking, Promoter Share, Promoter Cost';

/**
 * Asks what to do with survey records after a test user/account switch.
 * Emits true = delete them, false = keep them active, null = dialog dismissed (abort save).
 */
export function askTestSurveyRecordsAction(
  dialog: MatDialog,
  isTest: boolean,
  subject: 'user' | 'account' = 'user'
): Observable<boolean | null> {
  // Avoid the word "error" in messages: the dialog then switches to its error layout.
  const whose =
    subject === 'user'
      ? 'this user'
      : 'all stores of this account';
  const title = isTest
    ? `Mark as Test ${subject === 'user' ? 'User' : 'Account'}`
    : `Remove Test ${subject === 'user' ? 'User' : 'Account'}`;
  const message = isTest
    ? `You are marking ${subject === 'user' ? 'this user' : 'this account'} as TEST.\n\n` +
      `From now on, any new data for ${whose} will be saved as TEST records (deleted automatically), so it will not show in reports or dashboards.\n\n` +
      `What should happen to the data already saved for ${whose}?\n` +
      `• Delete Data – remove it from reports and dashboards\n` +
      `• Keep Data – it stays in reports and dashboards\n\n` +
      `Applies to: ${SURVEY_LIST}.`
    : `You are changing ${subject === 'user' ? 'this user' : 'this account'} back to NORMAL (not test).\n\n` +
      `While it was a test ${subject}, the data of ${whose} was saved as TEST records (deleted), so it is not showing in reports or dashboards right now.\n\n` +
      `From now on, new data for ${whose} will be saved as normal records and will show in reports and dashboards as usual.\n\n` +
      `Do you want to bring back the old test records?\n` +
      `• Restore Data – old test records come back into reports and dashboards\n` +
      `• Keep Deleted – old test records stay deleted; only new data will show\n\n` +
      `Applies to: ${SURVEY_LIST}.`;
  return dialog
    .open(ConfirmationDialogComponent, {
      width: '560px',
      data: {
        title,
        message,
        cancelText: isTest ? 'Keep Data' : 'Restore Data',
        confirmText: isTest ? 'Delete Data' : 'Keep Deleted',
        confirmButtonColor: 'warn',
        showOkButton: false,
      },
    })
    .afterClosed()
    .pipe(
      map((result) =>
        result === 'confirm' ? true : result === 'cancel' ? false : null
      )
    );
}
